import { render, staticRenderFns } from "./page8_circle.vue?vue&type=template&id=0b519118&scoped=true&"
import script from "./page8_circle.vue?vue&type=script&lang=js&"
export * from "./page8_circle.vue?vue&type=script&lang=js&"
import style0 from "./page8_circle.vue?vue&type=style&index=0&id=0b519118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b519118",
  null
  
)

export default component.exports